type ActionPlanSubmissionMapper = {
  surveyUuid: string;
  date: Date;
};

const storageKey = 'actionPlanSubmissions';

// Keep submissions for 1 year before cleaning up
const CLEANUP_THRESHOLD_DAYS = 365;

export class ActionPlanSubmissionUtils {
  public static hasSubmittedActionPlan(surveyUuid: string): boolean {
    const previousSubmissions = this.getSubmittedActionPlans();
    return (
      previousSubmissions?.some((submission) => submission.surveyUuid === surveyUuid) ??
      false
    );
  }

  public static addNewActionPlanSubmission(surveyUuid: string): void {
    const existing = this.getSubmittedActionPlans();
    const cleaned = this.cleanupOldSubmissions(existing || []);
    const newSubmissions: ActionPlanSubmissionMapper[] = [
      ...cleaned,
      { surveyUuid, date: new Date() },
    ];
    this.saveToStorage(newSubmissions);
  }

  private static saveToStorage(
    newSubmissions: ActionPlanSubmissionMapper[],
  ): void {
    try {
      window.localStorage.setItem(
        storageKey,
        JSON.stringify(newSubmissions),
      );
    } catch (error) {
      console.error('Error saving action plan submission to localStorage:', error);
    }
  }

  private static getSubmittedActionPlans(): ActionPlanSubmissionMapper[] | null {
    try {
      const submissions = window.localStorage.getItem(storageKey);
      return submissions ? (JSON.parse(submissions) as ActionPlanSubmissionMapper[]) : null;
    } catch (error) {
      console.error('Error reading action plan submissions from localStorage:', error);
      return null;
    }
  }

  /**
   * Remove submissions older than CLEANUP_THRESHOLD_DAYS
   * Prevents localStorage from growing indefinitely
   */
  private static cleanupOldSubmissions(
    submissions: ActionPlanSubmissionMapper[],
  ): ActionPlanSubmissionMapper[] {
    const thresholdDate = new Date();
    thresholdDate.setDate(thresholdDate.getDate() - CLEANUP_THRESHOLD_DAYS);

    return submissions.filter((submission) => {
      const submissionDate = new Date(submission.date);
      return submissionDate >= thresholdDate;
    });
  }
}
